import React from "react";
import { IVersionsWrapper } from "../interfaces";

export interface IVersionsProps {
    versionsWrapper?: IVersionsWrapper;
}

const TabVersion = (props?: IVersionsProps) => {
    const versionsWrapper = props?.versionsWrapper;

    if(!versionsWrapper) return null;

    return (
        <div className="my-4">

            <div
                className={"my-4"}
                dangerouslySetInnerHTML={{ __html: versionsWrapper?.topBanner }}
            />

            {
                versionsWrapper.versions?.length > 0 &&
                <table className="table-fixed w-full text-base mt-8 rounded">
                    <thead style={{
                        position: 'sticky',
                        top: "136px"
                    }}>

                        <tr className="h-20 bg-gray-150">
                            <td className="font-bold border pl-4">Plugin</td>
                            <td className="font-bold border text-center-webkit">Versions</td>
                        </tr>

                    </thead>
                    <tbody>
                    {
                        versionsWrapper?.versions?.map((item, index) => {
                            return (
                                <tr key={ index }
                                    className="w-full h-20">
                                    <td className="border pl-4">{ item.documentName }</td>
                                    <td className="border text-center-webkit p-2">{ item.versions }</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            }

            <div
                className={"my-8"}
                dangerouslySetInnerHTML={{ __html: versionsWrapper?.bottomBanner }}
            />
        </div>
    )
};

export default TabVersion;